export const CARD_REGULAR = "CARD_REGULAR";
export const CARD_LONG = "CARD_LONG";
